import getMessage from 'src/background/utils/i18n.utils';
import React from 'react';
import { SVGIcons } from 'src/common-ui/icons.enum';
import RotatingLogoComponent from 'src/common-ui/rotating-logo/rotating-logo.component';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
const Loading = ({ hide, operations, caption, loadingPercentage }) => {
    return (React.createElement("div", { className: `loading-container ${hide ? 'hide' : ''}` },
        React.createElement("div", { className: "overlay" }),
        React.createElement(RotatingLogoComponent, null),
        caption && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "loading-caption" }, getMessage(caption)))),
        !caption && (React.createElement("div", { className: "loading-text" }, getMessage('popup_html_loading'))),
        React.createElement("div", { className: "operations" }, operations &&
            operations.map((operation) => (React.createElement("div", { className: "loading-operation", key: operation.name },
                React.createElement("span", { dangerouslySetInnerHTML: {
                        __html: getMessage(operation.name, operation.operationParams),
                    } }),
                !operation.hideDots && (React.createElement("div", null, operation.done ? (React.createElement(SVGIcon, { className: "icon-done", icon: SVGIcons.MESSAGE_SUCCESS })) : ('...'))))))),
        loadingPercentage && (React.createElement("div", { className: "progress-bar-container" },
            React.createElement("div", { className: "progress-bar", style: { width: `${loadingPercentage}%` } }, loadingPercentage > 10 && `${loadingPercentage.toFixed(0)}%`)))));
};
export const LoadingComponent = Loading;
